export default __webpack_public_path__ + "static/Lato-Regular-319df0f5492062b546b0de9dcb568cb9.woff";